import type React from 'react';
import { lazy, Suspense } from 'react';

const LazySupport = lazy(() => import('./Support'));

const Support = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazySupport {...props} />
  </Suspense>
);

export const supportRoute = {
  path: '/support',
  element: <Support />,
};

export default Support;
